// extracted by mini-css-extract-plugin
export default {"checkbox":"RoundedCheckbox_checkbox__+snEN","unchecked":"RoundedCheckbox_unchecked__ssIRX","checked":"RoundedCheckbox_checked__D2M7Q"};